import { Box, Button, ColorOptions, Form, Image, ModBox, Spacer, Text } from '@jfs/ui-new'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { FC, ReactElement, useEffect, useState } from 'react'
import { useLazyApiData, useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import { Colors, isSessionValid, useWindowDimensions } from '../../../util/util'
import CountDownTimer from './CountDownTimer'
import { otpForm } from './FormData'
import { styles } from './styles'
import { DefaultFormContainer } from '../../../comps/DefaultFormContainer'

interface OtpProps {
  isFromForgotPwd?: boolean
  hide?: boolean
  mobileNumber?: string
  onBack?: () => void
  getOtpEntered?: (otp: string) => void
  isSignUp?: boolean
}

const renderOtpActionButtons = ({
  handleSubmit,
  handleVerifyPress,
  themedStyle,
  values,
  mobileNumber,
  getListHandler,
  OtpHandler,
}: any): ReactElement => {
  const handleOtpSubmitPress = (): void => {
    handleSubmit()
    if (values.otp && String(values.otp).trim().length > 5) {
      handleVerifyPress(String(values.otp))
    }
  }
  return (
    <>
      <Box {...themedStyle.otpButtonContainer}>
        <Button
          isLoading={OtpHandler?.state === 'pending' || getListHandler.state === 'pending'}
          disabled={String(values.otp)?.trim()?.length < 6}
          isFull
          type={'primary'}
          color={'#0070B6' as ColorOptions}
          testID="verify-otp"
          onPress={handleOtpSubmitPress}>
          <Text color={'WHITE'} fontFamily={'jiotype-medium'} fontSize={14}>
            {'Verify OTP'}
          </Text>
        </Button>
      </Box>
      <Box marginTop={25}>
        <CountDownTimer count={30} mobile={mobileNumber} />
      </Box>
    </>
  )
}

const QrAgentOtp: FC<OtpProps> = () => {
  const hide = false
  const { setSessionVerified, resetAccessToken, mobileNumber, loginVerifyOTP, getMidsQrList, midList, initialized } =
    useStores((root) => ({
      setSessionVerified: root.agentQrSession.setSessionVerified,
      resetAccessToken: root.agentQrSession.resetAccessToken,
      mobileNumber: root.agentQrUser.mobile,
      loginVerifyOTP: root.agentQrUser.loginVerifyOTP,
      getMidsQrList: root.agentQrUser.getMidsQrList,
      midList: root.agentQrUser.midList,
      presentScreenName: root.agentQrSession.presentScreenName(),
      updateNavigatedScreenName: root.agentQrSession.updateNavigatedScreenName,
      initialized: root.agentQrSession.initialized,
    }))
  // const notRegisteredCode = '22446'
  const navigation = useNavigation()
  const [isListCalled, setIsListCalled] = useState(false)
  const [loginWithOTP, OtpHandler] = useLazyApiData(loginVerifyOTP)
  const [callGetList, getListHandler] = useLazyApiData(getMidsQrList)

  const isFocused = useIsFocused()
  const viewPort = useWindowDimensions()

  useEffect(() => {
    if (OtpHandler.state === 'fulfilled') {
      //TODO: Check if we need this create user call here
      // const responseCode = OtpHandler?.data?.code
      // if (responseCode === notRegisteredCode) {
      //   createUser(OtpHandler?.data?.authorizationCode)
      // } else {
      if (!isListCalled) {
        setIsListCalled(true)
        callGetList()
      }
    } else if (OtpHandler.state === 'rejected') {
    }
  }, [OtpHandler.state, callGetList, isListCalled])

  useEffect(() => {
    console.log(midList)
    if (getListHandler.state === 'fulfilled') {
      setSessionVerified(true)
      navigation.reset({
        index: 0,
        routes: [
          {
            name: 'midslist',
          },
        ],
      })
    } else if (getListHandler.state === 'rejected') {
      setSessionVerified(false)
      console.log('Error msg', getListHandler?.data?.message)
    }
  }, [getListHandler, getListHandler.state, midList, navigation, setSessionVerified])

  useEffect(() => {
    if (!initialized && isFocused) {
      if (navigation?.canGoBack()) {
        navigation.goBack()
      } else {
        const csoSessData = window.localStorage.getItem('csoSessData')
        console.log('csoSessData', csoSessData)
        if (csoSessData && csoSessData?.length > 0 && isSessionValid(csoSessData)) {
          navigation.reset({
            index: 0,
            routes: [{ name: Routes.midslist }],
          })
        } else {
          navigation.reset({
            index: 0,
            routes: [{ name: Routes.QrAgentLogin }],
          })
          resetAccessToken()
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFocused, navigation, resetAccessToken])

  const initValues = {
    otp: '',
  }

  const handleVerifyPress = (otp: string): void => {
    loginWithOTP(otp)
  }

  const getFormData = (): any[] => {
    const initialFormData = [...otpForm()]
    return initialFormData
  }

  const handleOtpCancelPress = (): any => {
    resetAccessToken()
    navigation.reset({
      index: 0,
      routes: [
        {
          name: Routes.QrAgentLogin,
        },
      ],
    })
  }

  const renderAction = ({ handleSubmit, values }: any): ReactElement => {
    console.log('values', values)
    return renderOtpActionButtons({
      handleSubmit,
      handleVerifyPress,
      themedStyle,
      values,
      mobileNumber,
      getListHandler,
      OtpHandler,
    })
  }

  if (hide) {
    return null
  }

  const themedStyle = styles(viewPort)

  return (
    <Box
      w={'100%'}
      h={'100vh'}
      alignItems={'center'}
      justifyContent={'flex-start'}
      backgroundColor={Colors.SPLASH as ColorOptions}
      safeArea>
      <Box h={32} w={'100%'} alignItems={'center'} justify={'center'} margin={36}>
        <Image source={require('../../../assets/images/jiopaybuzz_white.png')} height={32} width={143} />
      </Box>
      <Box
        bg={'WHITE'}
        justifyContent={'center'}
        alignItems={'center'}
        borderRadius={8}
        minWidth={viewPort > 432 ? 320 : viewPort - 36}
        minHeight={viewPort > 432 ? 280 : undefined}>
        <Box marginTop={32}>
          <ModBox testID="arrow-back" onPress={handleOtpCancelPress} {...themedStyle.backTouchableStyle}>
            <Image source={require('../../../assets/images/keyboard_backspace.png')} width={32} height={32} />
          </ModBox>
          <Spacer size={8} />
          <Text {...themedStyle.enterOtpStyle}>{'Enter OTP'}</Text>
          <Box {...themedStyle.userInfoContainer}>
            <Text {...themedStyle.userInfoStyle}>{'We have sent 6 digit OTP to your number'}</Text>
            <Spacer size={5} direction="vertical" />
            <Box
              testID="change-mobile"
              onPress={handleOtpCancelPress}
              underlayColor={'TRANSPARENT'}
              flexDirection={'row'}>
              <Text {...themedStyle.mobileNumberStyle}>{mobileNumber}</Text>
              <Spacer size={5} direction={'horizontal'} />
              <Text {...themedStyle.editStyle}>{'(Change)'}</Text>
            </Box>
            <Spacer size={24} direction="vertical" />
          </Box>
          <Box {...themedStyle.formContainer}>
            <Form
              initialValues={initValues}
              container={DefaultFormContainer}
              formData={getFormData()}
              actionButtons={renderAction}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export { QrAgentOtp as default }
